// extracted by mini-css-extract-plugin
module.exports = {"avatar-wrap":"avatar-wrap___9tcXj"};